exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".carousel[data-v-071a0ce1]{box-shadow:0 0 5px rgba(0,0,0,.3)}.bloc[data-v-071a0ce1]{margin-top:15px}.caracs[data-v-071a0ce1]{font-size:12px;color:#262626;width:100%}.caracs tr td[data-v-071a0ce1]{padding-bottom:1em;min-height:1.5em}.caracs tr td[data-v-071a0ce1]:first-child:not(:last-child){color:#777;padding-right:15px;white-space:nowrap;font-weight:300}.caracs tr td[data-v-071a0ce1]:last-child:not(:first-child){text-align:right}.caracs-parent.row>[data-v-071a0ce1]:not(:first-child){border-left:1px solid #b1b1b1}.caracs-parent.row>[data-v-071a0ce1]:not(:last-child){border-right:1px solid #b1b1b1;margin-right:-1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-071a0ce1","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/FicheC.vue
// module id = 54
// module chunks = 0